import gql from 'graphql-tag';

export default gql`
  mutation adminArchiveOrganization($organizationId: ID!) {
    adminArchiveOrganization(organizationId: $organizationId) {
      id
    }
  }
`;
